module.exports = __webpack_public_path__ + "img/poly-10.8f6e7899.png";